<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer013">
<p class="CT" id="_idParaDest-1"><span class="CharOverride-1"><a id="_idTextAnchor000"></a>T</span><span class="CharOverride-2">HE</span><span class="CharOverride-1"> Z</span><span class="CharOverride-2">ANZIBAR</span><span class="CharOverride-1"><br/>C</span><span class="CharOverride-2">HEST</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V2891.vue?05440fb0